var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{class:_vm.classes,attrs:{"text":_vm.text,"color":_vm.color,"outlined":_vm.isOutlined,"large":_vm.medium}})}
var staticRenderFns = []

export { render, staticRenderFns }